import type { AxiosResponse } from 'axios';

import { baseUrl, formRoutes } from '@/api/config';
import axiosInstance from '@/api/instance';

import ROUTES from '../../routes';
import type {
  IInstallGPSTracker,
  IInstallSidesAdv,
  IInstallStaticAdv,
  IInstallStaticDevice,
  IRemoveBoxDevice,
  IRemoveDevice,
  ICommonInstallForm,
  IStaticAdv,
  IRemoveSides,
} from './types';

export const getStaticAdv = ()
  : Promise<void | AxiosResponse<IStaticAdv>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.INSTALL_STATIC_ADV}/adv-list`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getInstallSidesAdv = ()
  : Promise<void | AxiosResponse<IStaticAdv>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.INSTALL_SIDES_ADV}/adv-list`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const submitDevice = (data: IInstallStaticDevice | IInstallGPSTracker)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.INSTALL_DEVICE}/submit`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const submitBacklit = (data: IInstallStaticAdv)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.INSTALL_STATIC_ADV}/submit`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const submitSidesAdv = (data: IInstallSidesAdv)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.INSTALL_SIDES_ADV}/submit`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const submitRemoveDevice = (data: IRemoveDevice | IRemoveBoxDevice)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.REMOVE_DEVICE}/submit`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const submitRemoveBoxAdv = (data: ICommonInstallForm)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.REMOVE_BOX_ADV}/submit`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const submitRemoveSidesAdv = (data: IRemoveSides)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.REMOVE_SIDES_ADV}/submit`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});